import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const LuckyWheel = ({ onSpin, luckyWheelPrizes, startSpinAnimation, getLocalizedPrizeName }) => {
    const getBaseRotation = (length) => {
        switch (length) {
            case 3:
                return 60;
            case 6:
                return 30;
            case 9:
                return 20;
            case 12:
                return 16;
            default:
                return 16;
        }
    };

    return (
        <div className='lucky-wheel'>
            <LazyLoadImage src='/public/html/images/lucky-wheel/crystal-1.gif' className='crystal-1' alt='crystal-1' />
            <LazyLoadImage src='/public/html/images/lucky-wheel/crystal-2.gif' className='crystal-2' alt='crystal-2' />
            <LazyLoadImage src='/public/html/images/lucky-wheel/crystal-3.gif' className='crystal-3' alt='crystal-3' />
            <LazyLoadImage src='/public/html/images/lucky-wheel/flag-1.png' className='flag-1' alt='flag-1' />
            <LazyLoadImage src='/public/html/images/lucky-wheel/flag-2.png' className='flag-2' alt='flag-2' />
            <div>
                <div className='wheel-container' id='spinInnerWheel'>
                    <LazyLoadImage src={`/public/html/images/lucky-wheel/inner-wheel-${luckyWheelPrizes?.length || 12}.png`} className='inner-wheel' alt='inner-wheel' />
                    <ul className='prize-name-list'>
                        {(luckyWheelPrizes || []).map((prize, i) => (
                            <li
                                key={prize.seq}
                                id={`prize-${prize.seq}`}
                                style={{
                                    transform: `rotate(${getBaseRotation(luckyWheelPrizes?.length) + (360 / luckyWheelPrizes?.length) * i}deg)`,
                                    width: `${100 / luckyWheelPrizes.length + 5}%`,
                                    color: i % 2 === 0 ? '#FF4F03' : undefined,
                                }}
                            >
                                {getLocalizedPrizeName(prize)}
                            </li>
                        ))}
                    </ul>
                </div>
                <span
                    id='spin'
                    className='lucky-wheel-spin-btn'
                    onClick={onSpin}
                    style={{
                        filter: startSpinAnimation ? 'grayscale(100%)' : 'none',
                        pointerEvents: startSpinAnimation ? 'none' : 'auto',
                        cursor: startSpinAnimation ? 'not-allowed' : 'pointer',
                    }}
                >
                    <LazyLoadImage src='/public/html/images/lucky-wheel/spin-btn.gif' alt='spin-button' />
                </span>
                <LazyLoadImage src='/public/html/images/lucky-wheel/lucky-wheel-outer-frame.gif' className='lucky-wheel-frame' alt='outer-frame' />
            </div>
        </div>
    );
};

export default LuckyWheel;
